<svg class={$$props.class} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M20.604 16.196L16.604 20.196M16.604 20.196L12.604 16.196M16.604 20.196L16.604 10.596"
		stroke="#00253F"
		stroke-width="2.2"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M11.3999 7.80396L7.3999 3.80395M7.3999 3.80395L3.3999 7.80395M7.3999 3.80395L7.3999 13.404"
		stroke="#00253F"
		stroke-width="2.2"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
